import React, { useEffect, useState } from "react";
import { ApiService } from "../services/ApiService";
import { APIs } from "../constants/api.constants";
import { Button, message, notification, Spin } from "antd";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import "../public/styles/style.css";
import {
  dateFilterParams,
  frameworkComponents,
  gridOption,
} from "../constants/ag-grid.constants";
import DeleteNextInstructor from "../custom-components/next-instructor-popups/delete-next-instructor";
import axios from "axios";

export default function NextInstructorForm() {
  const [activities, setActivities] = useState([]);
  const [loadingRows, setLoadingRows] = useState(false);
  const [selectRowID, setSelectedRowID] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const columnDefs = [
    {
      headerName: "ID",
      field: "id",
      minWidth: 80,
      sort: "desc",
      editable: false,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
    },
    {
      headerName: "Done By",
      valueGetter: (param) => param.data?.email || "-",
      editable: false,
      minWidth: 150,
    },
    {
      headerName: "From Course",
      valueGetter: (param) => param.data?.course || "-",
      minWidth: 150,
      editable: false,
    },
    {
      headerName: "Instructor Suggestion",
      valueGetter: (param) => param.data?.nextInstructorName || "-",
      editable: false,
      minWidth: 150,
    },
    {
      headerName: "Created Date",
      field: "createDate",
      valueGetter: (param) =>
        new Date(param.data?.createDate)?.toLocaleString("en-GB") || "-",
      minWidth: 200,
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
    },
  ];

  useEffect(() => {
    getNextInstructorFormLog();
  }, []);

  async function getNextInstructorFormLog() {
    setLoadingRows(true);
    ApiService.getRequest(APIs.nextInstructorForm).then(
      (res) => {
        setLoadingRows(false);
        setActivities(res.data);
      },
      (error) => {
        setLoadingRows(false);
        notification["error"]({ message: "Having Problem Getting Data" });
      }
    );
  }

  function getSelectedRowData(event) {
    let selectedNodes = event.api.getSelectedNodes();
    let selectedData = selectedNodes.map((node) => node.data.id);
    setSelectedRowID(selectedData);
  }

  function hardDelete() {
    if (checkBox1 !== true || checkBox2 !== true) {
      return notification["error"]({
        message: "please check all the checkbox to confirm deletion",
      });
    }
    const postData = { list_id: selectRowID };
    setLoading(true);
    setLoadingRows(true);
    ApiService.postRequest(
      APIs.nextInstructorForm + "/multi-hard-delete",
      postData
    ).then(
      () => {
        setLoading(false);
        setSelectedRowID([]);
        toggleDeletePopup();
        getNextInstructorFormLog();
      },
      (error) => {
        notification["error"]({ message: error.message });
        setLoading(false);
        setSelectedRowID([]);
        toggleDeletePopup();
        setLoadingRows(false);
      }
    );
  }

  function resetDeleteInput() {
    setCheckBox1(false);
    setCheckBox2(false);
  }

  function toggleDeletePopup() {
    deleteVisible && resetDeleteInput();
    setDeleteVisible(!deleteVisible);
  }

  function downloadResult() {
    ApiService.getRequest(APIs.nextInstructorForm + "/download-xlsx").then(
      (response) => {
        const buf = new Uint8Array(response.data.data).buffer;
        const url = window.URL.createObjectURL(
          new Blob([buf], { type: "application/vnd.ms-excel;charset=utf-8r" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = `${Date.now()}_next_instructor_result.xlsx`;
        link.click();
      },
      (error) => {
        notification["error"]({ message: error.message });
      }
    );
  }

  const deletePorps = {
    loading,
    deleteVisible,
    toggleDeletePopup,
    checkBox1,
    setCheckBox1,
    checkBox2,
    setCheckBox2,
    selectRowID,
    hardDelete,
  };

  return (
    <>
      <div className={"d-flex w-100percent justify-content-end pb-3"}>
        <DeleteNextInstructor props={deletePorps} />
          <div className={"pb-3 pr-2 wfit"}>
            <Button type="primary" onClick={downloadResult}>
              Download Result
            </Button>
          </div>
      </div>
      <Spin tip="Loading...." size="small" spinning={loadingRows}>
        <div className="example-wrapper h-minus-180">
          <div className="ag-theme-alpine  w-100percent h-100percent">
            <AgGridReact
              rowData={activities}
              columnDefs={columnDefs}
              defaultColDef={gridOption}
              enableCellTextSelection={true}
              animateRows={true}
              frameworkComponents={frameworkComponents}
              getRowNodeId={function (data) {
                return data.id;
              }}
              onSelectionChanged={function (event) {
                return getSelectedRowData(event);
              }}
              rowSelection={"multiple"}
            ></AgGridReact>
          </div>
        </div>
      </Spin>
    </>
  );
}
